import React, { useMemo } from 'react';
import { KeyMetricData } from 'src/types';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';
import { useKpiUnit } from '../../../../../hooks/useKpiUnit';
import { useLTDataContext } from '../../../contexts/LTDataContext';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { TrendingUp } from 'lucide-react';

export const TotalEffect: React.FC = () => {
  const { effects, isError, isLoading } = useLTDataContext();

  const { isEuro } = useKpiUnit();

  const keyMetricData: KeyMetricData = useMemo(() => {
    let sum = 0;
    const data = effects.monthly.map((x) => {
      const value = x.totalMediaEffect;
      sum += value;
      return {
        utcEpoch: x.utcEpoch,
        value,
      };
    });

    return {
      name: 'Total effect',
      data,
      isEuro,
      summaryValue: sum,
      isError,
      isLoading,
    };
  }, [effects, isError, isLoading, isEuro]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricCard
      isEuro={keyMetricData.isEuro}
      title="Total effect"
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={isLoading}
      isError={isError}
      icon={<ChakraIcon as={TrendingUp} boxSize={5} color="gray.500" />}
    />
  );
};
